import {RemoteGetProgress} from 'data/usecases/private/profile/remote-get-progress';
import {GetProgress} from 'domain/usecases/private/profile/get-progress';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {ProfileEndpoints} from 'main/factories/usecases/endpoints';

export const makeGetProgress = (): GetProgress =>
	new RemoteGetProgress(
		makeBFFApiUrl(ProfileEndpoints.progress),
		makeAuthorizeHttpClientDecorator(),
	);
